module.exports = __webpack_public_path__ + "static/media/CalendarEvent6.e1fd8964.jpg";